import { GEOAPIFY_API_KEY } from '../constants/placeTypes';

// Fetch 10-minute walking isochrone from Geoapify API
export const fetchIsochrone = async (location) => {
  const { lat, lng } = location;
  const url = `https://api.geoapify.com/v1/isoline?lat=${lat}&lon=${lng}&type=time&mode=walk&range=600&apiKey=${GEOAPIFY_API_KEY}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Geoapify API returned status: ${response.status}`);
    }
    const data = await response.json();

    if (data && data.features && data.features.length > 0) {
      return data;
    } else {
      throw new Error('No isochrone data received from API');
    }
  } catch (error) {
    console.error('Error fetching isochrone data:', error);
    throw error;
  }
};

// Ray casting against one linear ring of [lng, lat] pairs.
const inRing = (ring, lng, lat) => {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if ((yi > lat) !== (yj > lat) && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
};

// First ring is the outline, the rest are holes.
const inPolygon = (rings, lng, lat) =>
  rings.length > 0 && inRing(rings[0], lng, lat) && !rings.slice(1).some((hole) => inRing(hole, lng, lat));

// True when {lat, lng} lies inside the isochrone GeoJSON returned by
// fetchIsochrone (FeatureCollection of Polygon / MultiPolygon). The tool
// never shows a place outside this area.
export const isInsideIsochrone = (isochrone, point) => {
  if (!isochrone || !isochrone.features) return false;
  return isochrone.features.some((feature) => {
    const g = feature.geometry;
    if (!g) return false;
    if (g.type === 'Polygon') return inPolygon(g.coordinates, point.lng, point.lat);
    if (g.type === 'MultiPolygon') return g.coordinates.some((rings) => inPolygon(rings, point.lng, point.lat));
    return false;
  });
};
